export class CertificationViewModel {
    id = 0;
    name = '';
    abbreviation = '';
    willExpire = false;
    proofRequired = false;
    attachment = null;
    isActive = true;
    showOnDispatchBoard = true;
    showOnDispatchPlusHandoffEmail = true;
    mustBeValidForDispatch = false;
    tenantId = 0;
    incentiveAmount = 0.00;
}
